export type BackgroundId = 'graph' | 'scifi' | 'skyline';

export interface BackgroundConfig {
  id: BackgroundId;
  label: string;
  file: string;
  darkness: number;
}

export const BACKGROUNDS: BackgroundConfig[] = [
  { id: 'graph', label: 'Graph', file: 'assets/images/bg-graph.png', darkness: 0.6 },
  { id: 'scifi', label: 'Sci-Fi', file: 'assets/images/bg-scifi.jpg', darkness: 0.6 },
  { id: 'skyline', label: 'Skyline', file: 'assets/images/bg-skyline.jpg', darkness: 0.4 },
];

export interface GameSettings {
  dotKey: string;
  dashKey: string;
  sfxVolume: number;
  musicVolume: number;
  background: BackgroundId;
}

const SETTINGS_KEY = 'morse-hero-settings';

const defaultSettings: GameSettings = {
  dotKey: 'G',
  dashKey: 'H',
  sfxVolume: 0.7,
  musicVolume: 0.5,
  background: 'graph',
};

export function getBackgroundConfig(id: BackgroundId): BackgroundConfig {
  return BACKGROUNDS.find(bg => bg.id === id) ?? BACKGROUNDS[0];
}

export function loadSettings(): GameSettings {
  try {
    const saved = localStorage.getItem(SETTINGS_KEY);
    if (saved) {
      return { ...defaultSettings, ...JSON.parse(saved) };
    }
  } catch (e) {
    console.warn('Failed to load settings:', e);
  }
  return { ...defaultSettings };
}

export function saveSettings(settings: Partial<GameSettings>): GameSettings {
  const current = loadSettings();
  const updated = { ...current, ...settings };

  try {
    localStorage.setItem(SETTINGS_KEY, JSON.stringify(updated));
  } catch (e) {
    console.warn('Failed to save settings:', e);
  }

  return updated;
}

export function resetSettings(): GameSettings {
  try {
    localStorage.removeItem(SETTINGS_KEY);
  } catch (e) {
    console.warn('Failed to reset settings:', e);
  }
  return { ...defaultSettings };
}
